import React, { useState } from 'react';
import { DataGridUI, DataGridIdentifiers, ButtonUI } from '../Interface';
import { dataGridColumns } from '../../utils/helper';
import { TaskReport } from '../../config/taskReport';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Box, Typography } from '@mui/material';
import TaskReportAttachmentsDialog from './TaskReportAttachmentsDialog';

const TaskReports = ({ reportList }) => {
  const [attachDialogData, setAttachDialogData] = useState({ open: false, attachments: [] });

  const columns = dataGridColumns([
    {
      field: 'timeSpent',
      headerName: 'Ráfordított idő',
      flex: 0.5,
      valueGetter: (params) => {
        const me = params.row.me;
        const timeSpent = params.row.timeSpent;
        const formattedTimeSpent = me === TaskReport.óra ? 'óra' : 'perc';
        return `${timeSpent} ${formattedTimeSpent}`;
      },
    },
    {
      field: 'typeId',
      headerName: 'Feladattípus',
      flex: 0.5,
      valueGetter: (params) => {
        const taskType = params.row.taskType?.itemName;
        return taskType;
      },
    },
    {
      field: 'description',
      headerName: 'Megjegyzés',
      flex: 1,
    },
    {
      field: 'taskReportAttachment',
      headerName: 'Csatolmányok',
      type: 'string',
      renderCell: (data) => {
        return (
          <ButtonUI
            size="sm"
            className="bg-success px-2.5 py-1"
            onClick={() => {
              setAttachDialogData({
                open: true,
                attachments: data.row.taskReportAttachment,
              });
            }}
            text={
              <Box display="flex">
                <AttachFileIcon fontSize="small" />
                <Typography fontSize="medium">{data.row.taskReportAttachment.length}</Typography>
              </Box>
            }
          />
        );
      },
    },
  ]);

  return (
    <>
      <DataGridUI
        getRowHeight={() => 'auto'}
        datagridIdentifier={DataGridIdentifiers.TaskReports}
        sx={{ height: 440, width: '100%' }}
        columns={columns}
        rows={reportList}
      />
      <TaskReportAttachmentsDialog
        dialogData={attachDialogData}
        handleClose={() => setAttachDialogData({ open: false, attachments: [] })}
      />
    </>
  );
};

export default TaskReports;
